"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { Select } from "./filter/select";

type Props = {
  id?: string;
  disabled?: boolean;
  paramName: string;
  className?: string;
  children: React.ReactNode;
};
function SelectSet({ id, disabled = false, paramName, className, children }: Props) {
  const searchParams = useSearchParams();
  return (
    <Select
      paramName={paramName}
      val={searchParams.get(paramName) ?? paramName}
      id={id || paramName}
      disabled={disabled}
      hasParam={searchParams.has(paramName)}
      className={className}
    >
      {children}
    </Select>
  );
}

export function SelectSetSearchParam(props: Props) {
  return (
    <Suspense
      fallback={
        <select className={`select ${props.className || "select-sm w-full max-w-xs"}`}>{props.children}</select>
      }
    >
      <SelectSet {...props} />
    </Suspense>
  );
}
